import React, { useState } from 'react';
import axios from 'axios';
import { Button } from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CreateAdmin = ({ onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    phoneNumber: '',
  });
  const [creating, setCreating] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.junctionverse.com';

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleCreateAdmin = async () => {
    if (!formData.email || !formData.fullName) {
      toast.error('Email and Full Name are required');
      return;
    }

    try {
      setCreating(true);
      const response = await axios.post(
        `${API_BASE_URL}/admin/admins/create`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'Content-Type': 'application/json',
          },
        }
      );

      toast.success(response.data.message || 'Admin user created successfully');
      
      // Reset form
      setFormData({
        email: '',
        fullName: '',
        phoneNumber: '',
      });

      // Notify parent
      if (onSuccess) {
        onSuccess();
      }

      // Close after delay
      setTimeout(() => {
        if (onClose) {
          onClose();
        }
      }, 1500);
    } catch (err) {
      console.error('Failed to create admin:', err);
      const errorMessage = err.response?.data?.error || 'Failed to create admin user';
      toast.error(errorMessage);
    } finally {
      setCreating(false);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      
      <div>
        <div className="mb-4">
          <h4>Create New Admin User</h4>
          <p className="text-muted">Fill in user details to create an admin user</p>
        </div>

        <div className="mb-3">
          <label className="form-label">Email *</label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="admin@example.com"
            required
            disabled={creating}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Full Name *</label>
          <input
            type="text"
            className="form-control"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="John Doe"
            required
            disabled={creating}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Phone Number</label>
          <input
            type="text"
            className="form-control"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            placeholder="+1234567890"
            disabled={creating}
          />
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <Button color="secondary" onClick={onClose} disabled={creating}>
            Cancel
          </Button>
          <Button 
            color="primary" 
            onClick={handleCreateAdmin}
            disabled={creating || !formData.email || !formData.fullName}
          >
            {creating ? 'Creating...' : 'Create Admin User'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateAdmin;
